// extracted by mini-css-extract-plugin
export var bulletWrapper = "bulletedListItem-module--bulletWrapper--61081";
export var dark = "bulletedListItem-module--dark--5f120";
export var itemText = "bulletedListItem-module--itemText--ce879";
export var itemWrapper = "bulletedListItem-module--itemWrapper--8b3e2";
export var light = "bulletedListItem-module--light--0f732";